import { useContext } from 'react';
import useSWR from 'swr';
import tabsContext from '../../../components/Tabs/tabsContext';
import appContext from '../../../context/app/appContext';
import CreateASpoolContext from '../../../context/createASpool/createASpoolContext';

const useStrategyAllocationDetails = () => {
    const { sdk } = useContext(appContext);

    const { selectedRiskModel, selectedStrategies, selectedAsset } =
        useContext(CreateASpoolContext);

    const { disabled } = useContext(tabsContext);

    const { data, error } = useSWR(
        sdk &&
            selectedStrategies?.length &&
            selectedRiskModel &&
            selectedAsset &&
            !disabled
            ? [
                  'estimatedAllocation',
                  selectedStrategies,
                  selectedRiskModel,
                  selectedAsset,
              ]
            : null,
        async (_, strategy, riskProvider, asset) => {
            const allocations = await sdk!.spools.getStrategyAllocations({
                strategy,
                riskProvider,
                asset,
            });

            const apys = await sdk!.spools.getStrategyApys(strategy);
            const risks = await sdk!.spools.getStrategyRisks(strategy, riskProvider);

            return { allocations, apys, risks };
        }
    );

    return {
        strategyAllocationDetails: data,
        isLoading: !error && !data,
        error,
    };
};

export default useStrategyAllocationDetails;
